import { router } from '@inertiajs/svelte'
import { trackSessionStart } from 'frontend/shared/javascripts/modules/convert_session_tracking'

// `navigate` also fires for the initial page
export function trackInertiaSessionStarts(): () => void {
  return router.on('navigate', () => trackSessionStart())
}
